import Head from "./Head";
export { Head };
